import React from 'react';
import Home from './images/home.png'

const Icon2 = () => {
    return (
        <div className="container-fluid">
            <img src={Home} alt="home icon" className="img-fluid" style={{maxWidth: "100%"}} />
        </div>
    )
}

export default Icon2